import namespace from '@/helpers/namespace';

export default namespace('reservation', {
  getters: [
    'groupUrlVendor',
    'groupVendor',
    'typeApiReportDownload',
    'apiReportDownload',
    'loadingReservation',
    'seoVendor',
    'showBlockedHours',
    'showBlockedDay',
    'showBlockedRange',
    'selectTableInfo',
    'tables',
    'sections',
    'services',
    'selectTableId',
    'notifications',
    'times',
    'blocked',
    'blockedHours',
    'availabilityTimes',
    'availability',
    'reservations',
    'reservationsDay',
    'schedules',
    'map',
    'list',
    'selectedMonth',
    'selectedDate',
    'dateFilterSelect',
    'sectionFilterSelect',
    'addReservation',
    'addWalkIn',
    'type',
    'infoReservation',
    'editReservation',
    'sectionSelected',
    'tableSelected',
    'tableSelectedId',
    'viewReservation',
    'verticalReservation',
    'requirements',
    'originVendor',
    'originVendorPeople',
    'updateSystem',
    'decorationCosto'
  ],
  actions: [
    'getGroup',
    'deleteReport',
    'generateReport',
    'generateReportPrevius',
    'generateReportUsers',
    'validateReservation',
    'updateReservationWalkIn',
    'reservationEliminar',
    'getInfoTracking',
    'getReservationUser',
    'getListUsers',
    'getInfoTable',
    'reservationEmail',
    'blockedDay',
    'unBlockedDay',
    'blockedDayTable',
    'unBlockedDayTable',
    'blockedHourTable',
    'unBlockedHourTable',
    'blockedUnBlocked',
    'blockedRange',
    'sections',
    'tables',
    'tableSection',
    'services',
    'notificationId',
    'notifications',
    'addWalkIn',
    'addReservation',
    'updateReservation',
    'reservationIsCancelled',
    'reservationIsConfirmed',
    'reservationIsSeated',
    'reservationIsFinish',
    'reservationIsNoShow',
    'undoReservationStatus',
    'blocked',
    'blockedHours',
    'availability',
    'availabilityTimes',
    'sectionStatus',
    'reservations',
    'reservationsDay',
    'reservationNew',
    'reservationNewDate',
    'times',
    'schedules',
    'map',
    'list',
    'searchHost',
    'searchUser',
    'notificationIsArch',
    'notificationIsSeen',
    'setBlockedSection',
    'setUnBlockedSection',
    'setBlockedTableSection',
    'setUnBlockedTableSection',
    'getRequirements',
    'getOriginVendor',
    'getOriginVendorPeople',
    'getUpdateSystem',
    'undoReservationStatusCancelled',
    'setUserConfirmReservation'
  ],
  mutations: [
    'setGroupUrlVendor',
    'setGroupVendor',
    'setTypeApiReportDownload',
    'setApiReportDownload',
    'setLoadingReservation',
    'setSeoVendor',
    'setSections',
    'setServices',
    'setTables',
    'setNotifications',
    'setSelectTableId',
    'setBlocked',
    'setTimes',
    'setMap',
    'setList',
    'setBlockedHours',
    'setAvailability',
    'setAvailabilityTimes',
    'setReservations',
    'setReservationsDay',
    'setSelectTableInfo',
    'setSelectedMonth',
    'setSelectedDate',
    'setSchedules',
    'setDateFilterSelect',
    'setSectionFilterSelect',
    'setShowBlockedHours',
    'setShowBlockedDay',
    'setShowBlockedDay',
    'setShowBlockedRange',
    'setAddReservation',
    'setAddWalkIn',
    'setInfoReservation',
    'setViewReservation',
    'setEditReservation',
    'setSectionSelected',
    'setTableSelected',
    'setTableSelectedId',
    'setResetDateFilterSelect',
    'setResetSectionFilterSelect',
    'setType',
    'setVerticalReservation',
    'setRequirements',
    'setOriginVendor',
    'setOriginVendorPeople',
    'setUpdateSystem',
    'setDecorationCosto'
  ]
});
